import { useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { Fragment } from 'react/jsx-runtime';
import './App.css';
import LoadingSpinner from './components/ui/loading-spinner/loading-spinner.component';
import HomePage from './routes/home/home.component';
import LoginPage from './routes/login/login.component';
import Navigation from './routes/navigation/navigation.component';
import { selectIsLoading } from './store/loading/loading.selector';

function App() {
    const isLoading = useSelector(selectIsLoading);

    return (
        <Fragment>
            {isLoading && <LoadingSpinner />}
            <Routes>
                <Route path="/" element={<Navigation />}>
                    <Route index element={<HomePage />} />
                    <Route path="login" element={<LoginPage />} />
                </Route>
            </Routes>
        </Fragment>
    );
}

export default App;
